import React, {useCallback, useState} from 'react';

import {useAlertFrequencyTypes} from 'src/hooks/dictionaries/useAlertDictionaries';
import {useAlertCriteria} from 'src/modules/profile/user/tabs/content/alerts/hooks/useAlertCriteria';
import {SCOPE_KEY} from 'src/modules/profile/user/tabs/content/alerts/util';
import {AlertFrequencyType} from 'src/openapi/admin/models/AlertFrequencyType';
import {AlertPageRequest} from 'src/openapi/admin/models/AlertPageRequest';
import {AlertSortField} from 'src/openapi/admin/models/AlertSortField';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import {SortHeaderFilter} from '@pb/kit-component-filters';
import Label from '@pb/kit-component-label';
import {Cell} from '@pb/kit-component-table';

import {apiToUiSort, uiToApiSort} from '../../utils/util';

export const FrequencyHeader = () => {
    const {criteria, setSort, setCriteria} = useAlertCriteria(SCOPE_KEY);
    const initialState = React.useMemo(() => ({frequency: undefined}), []);
    const [request, setRequest] = useState<Partial<AlertPageRequest>>(initialState);
    const {getAlertFrequencyTypeByCode} = useAlertFrequencyTypes();
    const direction =
        criteria?.alertSortField === AlertSortField.FREQUENCY
            ? apiToUiSort(criteria.sortDirection)
            : undefined;

    const onCancel = useCallback(() => (
        setRequest(criteria?.frequency
            ? {frequency: criteria.frequency}
            : initialState)
    ), [criteria?.frequency, setRequest, initialState]);

    return (
        <Cell className="text-align_center">
            <SortHeaderFilter
                caption="Frequency"
                filterActive={!!criteria?.frequency}
                sortable={true}
                direction={direction}
                defaultDirection="ASC"
                onSort={dir => setSort(AlertSortField.FREQUENCY, uiToApiSort(dir))}
                onReset={() => {
                    setRequest(initialState);
                    setCriteria(initialState);
                }}
                onCancel={onCancel}
                onApply={() => {
                    setCriteria(request);
                }}>
                <div>
                    <Label>Frequency</Label>
                    <ComboBox<AlertFrequencyType, AlertFrequencyType>
                        value={criteria?.frequency ? criteria.frequency : request.frequency ?? undefined}
                        onChange={val => setRequest({frequency: val})}
                        placeholder="Select Frequency">
                        {Object.values(AlertFrequencyType).filter(code => code !== AlertFrequencyType.NONE)
                            .map(code => (
                                <ComboboxItem
                                    key={code}
                                    caption={getAlertFrequencyTypeByCode(code)?.description || code}
                                    value={code}
                                />
                            ))}
                    </ComboBox>
                </div>
            </SortHeaderFilter>
        </Cell>
    );
};
